"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const store_1 = require("store");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const rfid_tag_hauler_styles_1 = __importDefault(require("../rfid-tag-hauler.styles"));
const rfid_tag_hauler_action_1 = __importDefault(require("../rfid-tag-hauler.action"));
const grid_1 = __importDefault(require("components/templates/grid"));
const authorization_1 = require("utils/authorization");
const rfid_tag_hauler_column_1 = require("../rfid-tag-hauler.column");
const modal_1 = require("components/molecules/modal");
const custom_cell_render_1 = __importDefault(require("./custom-cell-render"));
const rfid_tag_action_1 = __importDefault(require("../../rfid-tag.action"));
const modal_2 = require("components/molecules/modal");
const custom_cell_grid_1 = require("components/atoms/custom-cell-grid");
const debounces_1 = require("utils/debounces");
const HaulerRfidTag = () => {
    const { dataStates, isLoading, isError, errorMessage, dataGrid, mutationMode, dataItem, isSuccess } = (0, store_1.useAppSelector)(state => state.configuration.rfidTagHauler);
    const { appTheme } = (0, store_1.useAppSelector)(state => state.app);
    const { userData } = (0, store_1.useAppSelector)(state => state.auth);
    const { isLoading: mainLoading } = (0, store_1.useAppSelector)(state => state.configuration.rfidTag);
    const navigate = (0, react_router_dom_1.useNavigate)();
    const dispatch = (0, react_redux_1.useDispatch)();
    const debounceCallback = (0, debounces_1.useDebouncedCallback)((newDataStates) => {
        dispatch(rfid_tag_hauler_action_1.default.getDataGrid(newDataStates));
    }, 1000, [dispatch]);
    const [fullScreen, setFullScreen] = (0, react_1.useState)(true);
    const isAuthorized = (0, authorization_1.userRoleAuth)(userData.authorization, 'Configuration', 'Hauler');
    (0, react_1.useEffect)(() => {
        if (isAuthorized.view) {
            if (mainLoading || isLoading) {
                dispatch(rfid_tag_hauler_action_1.default.getDataGrid(dataStates));
            }
        }
        else {
            navigate('/dashboard', { replace: true });
        }
    }, [mainLoading, isAuthorized, fullScreen, isLoading]);
    (0, react_1.useEffect)(() => {
        if (!isLoading) {
            dispatch(rfid_tag_action_1.default.onClickMutation({ isLoading: false, mutationMode: false, isSuccess: false }));
        }
    }, [isLoading]);
    const onDataStateChange = (types, val) => {
        const newDataStates = Object.assign(Object.assign({}, dataStates), { skip: types === 'page' ? (val - 1) * dataStates.take : 0, take: types === 'take' ? val : dataStates.take });
        dispatch(rfid_tag_hauler_action_1.default.onDataStateChange(newDataStates));
    };
    const onFilterChange = (e) => {
        dispatch(rfid_tag_hauler_action_1.default.onFilterChange(e.filter));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { filter: e.filter });
        debounceCallback(newDataStates);
    };
    const onSortChange = (e) => {
        dispatch(rfid_tag_hauler_action_1.default.onSortChange(e.sort));
        const newDataStates = Object.assign(Object.assign({}, dataStates), { sort: e.sort });
        debounceCallback(newDataStates);
    };
    (0, react_1.useEffect)(() => {
        if (mutationMode === 'edit') {
            dispatch(rfid_tag_hauler_action_1.default.onSaveDataItem({ dataItem, isSuccess: false, mutationMode, isLoadingSubmit: true }));
        }
    }, [mutationMode]);
    const fullscreenColumnProps = (fullscreen) => {
        if (fullscreen) {
            return rfid_tag_hauler_column_1.rfidTagHaulerColumnFullWidthProps;
        }
        else {
            return rfid_tag_hauler_column_1.rfidTagHaulerColumnProps;
        }
    };
    const columnsRender = fullscreenColumnProps(fullScreen).map(item => {
        if (item.field === 'rfid_tag') {
            return Object.assign(Object.assign({}, item), { cell: (0, custom_cell_grid_1.customScanRfid)({
                    type: 'other',
                    permission: true,
                    onClick: dataItem => {
                        if (dataItem.rfid_tag === '') {
                            dispatch(rfid_tag_hauler_action_1.default.onClickMutation({ mutationMode: 'delete', dataItem }));
                        }
                        else {
                            dispatch(rfid_tag_hauler_action_1.default.onClickMutation({ mutationMode: 'edit', dataItem }));
                        }
                    }
                }) });
        }
        return item;
    });
    //checkfullscreen
    const widthCheker = () => {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        setFullScreen(width >= window.screen.width);
    };
    (0, react_1.useEffect)(() => {
        widthCheker();
    }, []);
    window.onload = widthCheker;
    window.onresize = widthCheker;
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(modal_1.ModalSuccess, { show: isSuccess, appTheme: appTheme, messageSuccess: 'Data Saved Successfully', onClose: () => {
                    dispatch(rfid_tag_hauler_action_1.default.getDataGrid(dataStates));
                    dispatch(rfid_tag_hauler_action_1.default.onClickMutation({ mutationMode: false, isSuccess: false }));
                } }), (0, jsx_runtime_1.jsx)(modal_1.ModalError, { show: isError, appTheme: appTheme, errorMessage: errorMessage, onClose: () => dispatch(rfid_tag_hauler_action_1.default.closeError()), style: { 'zIndex': 10 } }), (0, jsx_runtime_1.jsx)(modal_2.ModalConfirm, { show: mutationMode === 'delete', appTheme: appTheme, errorMessage: 'Are you sure to delete Hauler', errorSubject: `${dataItem.hauler_no} to ${dataItem.contractor_name}`, onClose: () => dispatch(rfid_tag_hauler_action_1.default.onClickMutation({ mutationMode: false })), onConfirm: () => dispatch(rfid_tag_hauler_action_1.default.onSaveDataItem({
                    dataItem: Object.assign(Object.assign({}, dataItem), { rfid_tag: '' }), isSuccess: false, mutationMode, isLoadingSubmit: true
                })) }), (0, jsx_runtime_1.jsx)(grid_1.default, { style: rfid_tag_hauler_styles_1.default.gridHeight, fullScreen: fullScreen, columns: columnsRender, pageable: true, sortable: true, sort: dataStates.sort, onPageChange: v => onDataStateChange('page', v), onTakeChange: v => onDataStateChange('take', v), onSortChange: onSortChange, onFilterChange: onFilterChange, dataStates: dataStates, dataGrid: dataGrid, cellRender: (0, custom_cell_render_1.default)() })] }));
};
exports.default = HaulerRfidTag;
